import { useState, useContext } from "react";
import FileUpload from "./FileUpload";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";

const ProfileImageUploader = ({ShowProfileImageUploadPopup, setShowProfileImageUploadPopup, setUserProfile , customerId}) => {

    const[error, setError] = useState(null);     
    const [selectedFile, setSelectedFile] = useState(null);
    const [isFilePicked, setIsFilePicked] = useState(false);     
    const [msg, setMsg] = useState(null);

    const {SiteConfig, token } = useContext(AppContext);
    
    function closeModal(){
        setShowProfileImageUploadPopup(false);
      }

      const handlechange = (e)=>{
    
        setSelectedFile(e.target.files[0]);
  
        //selectedFile.name = "dasda" + selectedFile.name;
        // let currFile = e.target.files[0];
        // let filename = "abcd" + currFile.name;
        // currFile.name = filename;
        // setSelectedFile(currFile)
        setIsFilePicked(true);
   
    
        //alert(selectedFile.name);
        //console.log(selectedFile);
        return null
      }  


      const handleUpload = () => {
    
        const frmFormData = new FormData();
        frmFormData.append('File', selectedFile);
          
        const sURL = SiteConfig.API_BASE_URL + "Storage/Upload/?context="+ "" +"&ID="+ customerId;
  
        const headers = {
          'Content-Type': selectedFile.type,
          'Authorization': 'Bearer '+ token //localStorage.getItem(SiteConfig.API_AUTH_TOKEN)      
        };
  
    
          axios.post(sURL,frmFormData,{headers})
          .then((Response)=>{              
            //console.log(Response.data)
             let res = Response.data

            setUserProfile(res.blob.uri)

             setMsg(res.status);
             setSelectedFile(null);
             setShowProfileImageUploadPopup(false);
             
          }).catch(error => {
              setError(error);     
             
          });
            
    };


    if (error) 
    {      
      if(error.message.indexOf("status code 401")){
        return <Navigate to="/auths/auth-login" />
      } else
      return "Error: ${error.message}";
    }


  return (
    <Modal show={ShowProfileImageUploadPopup} onHide={closeModal} size="lg" backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className="event-title" as="h4">Profile Image</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FileUpload handleUpload={handleUpload} handlechange={handlechange} isFilePicked={isFilePicked} msg={msg}/>
            </Modal.Body>            
        </Modal>
  )
}

export default ProfileImageUploader